var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommentsWithPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68681 2.68754C2.14698 3.22736 1.83325 4.07772 1.83325 5.33398V8.66732C1.83325 10.2909 2.16236 11.1034 2.6625 11.541C3.17916 11.9931 4.00876 12.1673 5.33325 12.1673H5.66659C5.85513 12.1673 6.03856 12.2262 6.18283 12.2977C6.32527 12.3683 6.48638 12.4794 6.60168 12.6363L7.59992 13.9673C7.73936 14.1532 7.88906 14.2073 7.99992 14.2073C8.11077 14.2073 8.26048 14.1532 8.39992 13.9673L9.39992 12.634L9.40184 12.6314C9.62162 12.3423 9.96797 12.1673 10.3333 12.1673H10.6666C11.9228 12.1673 12.7732 11.8536 13.313 11.3138C13.8529 10.7739 14.1666 9.92358 14.1666 8.66732V5.33398C14.1666 4.07772 13.8529 3.22736 13.313 2.68754C12.7732 2.14771 11.9228 1.83398 10.6666 1.83398H5.33325C4.07699 1.83398 3.22663 2.14771 2.68681 2.68754ZM1.9797 1.98043C2.77321 1.18692 3.92285 0.833984 5.33325 0.833984H10.6666C12.077 0.833984 13.2266 1.18692 14.0201 1.98043C14.8136 2.77394 15.1666 3.92358 15.1666 5.33398V8.66732C15.1666 10.0777 14.8136 11.2274 14.0201 12.0209C13.2266 12.8144 12.077 13.1673 10.6666 13.1673H10.3333C10.2855 13.1673 10.2323 13.192 10.1987 13.2356C10.1985 13.2359 10.1982 13.2362 10.198 13.2365L9.19992 14.5673C8.89936 14.9681 8.46906 15.2073 7.99992 15.2073C7.53078 15.2073 7.10048 14.9681 6.79992 14.5673L5.79909 13.2329C5.79761 13.2315 5.79461 13.2288 5.78972 13.225C5.77766 13.2156 5.76017 13.2043 5.73868 13.1936C5.71724 13.183 5.6968 13.1755 5.6804 13.171C5.67075 13.1684 5.66502 13.1676 5.66322 13.1673H5.33325C3.99108 13.1673 2.82068 13.0082 2.004 12.2936C1.17081 11.5646 0.833252 10.3771 0.833252 8.66732V5.33398C0.833252 3.92358 1.18619 2.77394 1.9797 1.98043Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99756 7.33268C9.99756 6.96449 10.296 6.66602 10.6642 6.66602H10.6702C11.0384 6.66602 11.3369 6.96449 11.3369 7.33268C11.3369 7.70087 11.0384 7.99935 10.6702 7.99935H10.6642C10.296 7.99935 9.99756 7.70087 9.99756 7.33268Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33032 7.33268C7.33032 6.96449 7.6288 6.66602 7.99699 6.66602H8.00298C8.37117 6.66602 8.66964 6.96449 8.66964 7.33268C8.66964 7.70087 8.37117 7.99935 8.00298 7.99935H7.99699C7.6288 7.99935 7.33032 7.70087 7.33032 7.33268Z",
    fill: "#2E3A59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66309 7.33268C4.66309 6.96449 4.96156 6.66602 5.32975 6.66602H5.33574C5.70393 6.66602 6.00241 6.96449 6.00241 7.33268C6.00241 7.70087 5.70393 7.99935 5.33574 7.99935H5.32975C4.96156 7.99935 4.66309 7.70087 4.66309 7.33268Z",
    fill: "#2E3A59"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsWithPoints);
export default __webpack_public_path__ + "static/media/commentsWithPoints.ff80cad4.svg";
export { ForwardRef as ReactComponent };